<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15bMkmf/tc-custom/9781467466820.jpg?1737334804437" alt="This image is the cover for the book The Letter to the Ephesians, The Pillar New Testament Commentary (PNTC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Letter to the Ephesians, The Pillar New Testament Commentary (PNTC)
      </h1>
      <p class="bookDescription body article font2">
        <b>A clear and comprehensive commentary on Paul’s Letter to the Ephesians.  </b><br/>  <br/> In the latest Pillar New Testament Commentary, Constantine R. Campbell illuminates the Letter to the Ephesians with scholarly precision and pastoral warmth. In line with the christological concerns of the letter, Campbell calls special attention to its theme of union with Christ. His thorough analysis covers a breadth of topics, including salvation and grace, the glory of God, and the church and its mission. <br/>  <br/> Aimed at students and scholars of the Pauline letters, Campbell’s commentary carefully explains each verse of Ephesians with attention to historical and linguistic context. Yet the commentary prioritizes imminent theological concerns and remains accessible to any serious reader of the New Testament.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Constantine R. Campbell
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Constantine R. Campbell</B>&#160;is associate research director at the Sydney College of Divinity. He is ordained deacon in the Anglican Church of Australia. His numerous books include&#160;<I>Paul and Union with Christ and Paul and the Hope of Glory.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c787a99